/**
 * @generated SignedSource<<5a76cccaaff083bc7f43e471ba300887>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AppPushStatusEnum = "completed" | "scheduled" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AppPushStatusLabel_appPush$data = {
  readonly status: AppPushStatusEnum;
  readonly " $fragmentType": "AppPushStatusLabel_appPush";
};
export type AppPushStatusLabel_appPush$key = {
  readonly " $data"?: AppPushStatusLabel_appPush$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppPushStatusLabel_appPush">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppPushStatusLabel_appPush",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "AppPush",
  "abstractKey": null
};

(node as any).hash = "b4bf5cb91e42e136d5ba114b2fa0cac6";

export default node;
